import { useState, useEffect } from 'react';
import PaymentService from '../services/payment.service';
import { CreditCard, Link as LinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

const PaymentsPage = () => {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPayments();
    }, []);

    const fetchPayments = async () => {
        try {
            const response = await PaymentService.getPayments();
            setPayments(response.data.results || []);
        } catch (error) {
            console.error("Failed to load payments", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold mb-8">Payments</h1>

            {loading ? <div>Loading...</div> : (
                <div className="bg-white rounded-3xl border border-zinc-100 overflow-hidden shadow-sm">
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-sm">
                            <thead className="bg-zinc-50 border-b border-zinc-100">
                                <tr>
                                    <th className="px-6 py-4 font-bold text-zinc-900">Reference</th>
                                    <th className="px-6 py-4 font-bold text-zinc-900">Date</th>
                                    <th className="px-6 py-4 font-bold text-zinc-900">Amount</th>
                                    <th className="px-6 py-4 font-bold text-zinc-900">Method</th>
                                    <th className="px-6 py-4 font-bold text-zinc-900">Status</th>
                                    <th className="px-6 py-4 font-bold text-zinc-900">Order</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-zinc-100">
                                {payments.map(payment => (
                                    <tr key={payment.id} className="hover:bg-zinc-50 transition-colors">
                                        <td className="px-6 py-4 font-mono text-zinc-600">{payment.transaction_id || "-"}</td>
                                        <td className="px-6 py-4 text-zinc-600">{new Date(payment.created_at).toLocaleDateString()}</td>
                                        <td className="px-6 py-4 font-bold">${payment.amount}</td>
                                        <td className="px-6 py-4 capitalize text-zinc-600">{payment.payment_method}</td>
                                        <td className="px-6 py-4">
                                            <span className={`inline-flex px-2 py-1 rounded-md text-xs font-bold capitalize ${payment.status === 'completed' ? 'bg-green-100 text-green-700' :
                                                    payment.status === 'failed' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'
                                                }`}>
                                                {payment.status}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4">
                                            {payment.order && (
                                                <Link to={`/orders/${payment.order}`} className="text-blue-600 hover:underline flex items-center gap-1">
                                                    View <LinkIcon size={12} />
                                                </Link>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {payments.length === 0 && (
                        <div className="p-12 text-center text-zinc-500">
                            <CreditCard size={48} className="mx-auto mb-4 text-zinc-300" />
                            No payment history found.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PaymentsPage;
